module.exports = __webpack_public_path__ + "static/media/wave-triangle.48ad3f00.svg";